module.exports = __webpack_public_path__ + "static/projekt-etykiety-lewandowski-b690fb2456df0526976150da1801ed33.png";